import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
	constructor(private router: Router, private userService: UserService) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		const expectedRoles: string[] = route?.data?.roles || [];
		const user = this.userService?.getCurrentUser();
		const currentUrl = state.url;

		if (!user) {
			this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
			return false;
		}

		// Higher level roles bypass specific checks if they are in expectedRoles
		if (user?.roles?.some(role => expectedRoles.includes(role))) {
			const isHighLevelAdmin = user?.roles?.some(role => ['Admin', 'SuperAdmin', 'Owner']?.includes(role));

			// Special check for Admin/SuperAdmin subscription
			if (
				route?.routeConfig?.path !== 'super-admin' &&
				isHighLevelAdmin &&
				!user?.subscription?.toString()?.length
			) {
				if (currentUrl === '/admin/account' || currentUrl.includes('subscription')) {
					return true;
				}
				this.router.navigate(['']); // Navigate to dashboard or home
				return false;
			}
			return true;
		} else {
			// Not authorized
			this.router.navigate(['/front/dashboard']); // Fallback page
			return false;
		}
	}

	canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(next, state);
	}

	canDeactivate(
		component: unknown,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot
	) {
		return true;
	}
}
